import { localizedString } from './fields/localizedString'; // Import the localizedString field
import { localizedText } from './fields/localizedText';
import { homePage } from './pages/homePage';
import { coreValues } from './sections/factory/coreValues';
import { cta } from './sections/factory/cta';
import { hero } from './sections/factory/hero';
import { partners } from './sections/factory/partners';
import { qualityPillars } from './sections/factory/qualityPillars';
import { showcaseGrid } from './sections/factory/showcaseGrid';
import { statistics } from './sections/factory/statistics';
import { trust } from './sections/factory/trust';
import { factory } from './sections/factory';
import { aboutPage } from './pages/aboutPage';
import { seoOptimizedImageUrl } from './fields/seoOptimizedImageUrl';
import { seo } from './sections/seo';
import { intro } from './sections/factory/intro';
import { videoSection } from './sections/factory/videoSection';
import { timelineSection } from './sections/factory/timelineSection';
import { tabsSection } from './sections/factory/tabsSection';
import { carouselSection } from './sections/factory/carouselSection';
import { faq } from './sections/factory/faq';
import { team } from './sections/factory/team';
import { accordionSection } from './sections/factory/accordionSection';
import { imageGallery } from './sections/factory/imageGallery';
import { productShowcase } from './sections/factory/productShowcase';
import { contactPage } from './pages/contactPage';
import { heroWithMascot } from './sections/factory/heroWithMascot';
import { menuPage } from './pages/menuPage';
import { grid } from './sections/grid';

export const schemaTypes = [
    // Documents
    homePage,
    aboutPage,
    contactPage,
    menuPage,

    // Sections
    seo,
    grid,

    // Fields
    localizedString,
    localizedText,
    seoOptimizedImageUrl,

    // Factory sections
    factory,
    hero,
    coreValues,
    cta,
    trust,
    partners,
    showcaseGrid,
    qualityPillars,
    statistics,
    intro,
    videoSection,
    timelineSection,
    tabsSection,
    carouselSection,
    faq,
    team,
    accordionSection,
    imageGallery,
    productShowcase,
    heroWithMascot,
];
